// RC6.2 Slice 6 · C1 — pure UI mapping for the advisory photo-relevance verdicts.
import api from "@/lib/api";

export const RELEVANCE = {
  RELEVANT: { label: "Looks relevant", tone: "text-brand-dark", allowComplete: true, retake: false },
  UNCERTAIN: { label: "AI couldn't confirm relevance", tone: "text-amber-600", allowComplete: true, retake: false },
  CLEARLY_IRRELEVANT: { label: "This photo may not match the task", tone: "text-red-600", allowComplete: false, retake: true },
  UNAVAILABLE: { label: "AI verification unavailable", tone: "text-slate-500", allowComplete: true, retake: false },
};

export function verdictUi(v) {
  return RELEVANCE[v] || RELEVANCE.UNAVAILABLE;
}

// Advisory only: AI NEVER blocks completion on its own. CLEARLY_IRRELEVANT prompts a retake, but the
// strict PHOTO-REQUIRED rule is enforced separately (a successful upload is still mandatory).
export function canCompleteWithRelevance(verdict, photoUploaded, photoRequired) {
  if (photoRequired && !photoUploaded) return false; // photo-required stays strict (fail-closed)
  return true; // AI availability/verdict is fail-open and never blocks on its own
}

export function shouldPromptRetake(verdict) {
  return verdictUi(verdict).retake === true;
}

// Advisory network call. ALWAYS fail-open: any error (module disabled 403, permission, network,
// provider failure) resolves to "UNAVAILABLE" so AI availability never becomes a completion
// dependency. Returns one of the four RELEVANCE keys.
export async function fetchPhotoRelevance({ fileId, taskTitle, taskDescription, siteId }) {
  try {
    const { data } = await api.post("/ai/photo-relevance", {
      file_id: fileId,
      task_title: taskTitle || null,
      task_description: taskDescription || null,
      site_id: siteId || null,
    });
    const v = data?.verdict;
    return v && RELEVANCE[v] ? v : "UNAVAILABLE";
  } catch {
    return "UNAVAILABLE";
  }
}
